<i18n src="@/locales/models/quality_inspect.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/agro_exporter/quality_control/crop_field/list_export_quality_inspects.yml"
  lang="yaml"
></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    name="ae_quality_control_crop_field_list_templates_path"
    :params="{
      agro_exporter_id: agro_exporter_id,
      producer_id: producer_id,
      crop_field_id: crop_field_id
    }"
  ></go-back-link>

  <bread-crumbs
    :labels="[
      module_name,
      crop_field?.producer?.fullname,
      crop_field?.name,
      quality_template?.name
    ]"
  ></bread-crumbs>

  <template v-if="load_data_general">
    <crop-field-info :crop_field="crop_field"></crop-field-info>

    <div class="mt-6">
      <h1 class="page-title">
        <i class="fa-solid fa-list-ul"></i><span class="space-icon"></span>
        {{ $t("labels.quality_inspects_title") }}
      </h1>

      <div class="mt-8 flex flex-row justify-between">
        <div class="panel-plain-label">
          <badge-default
            :label="
              quality_inspects.length + ' ' + $t('labels.total_number_inspections')
            "
          />
        </div>
        <div>
          <!-- <button
            type="button"
            @click.prevent="downloadRepXlsx()"
            class="btn-white"
          >
            <i :class="['fa-solid', downloading ? 'fa-sync fa-spin'  : 'fa-file-excel']"></i
            ><span class="space-icon"></span
            >{{ $t("labels.general_report_button") }}
          </button>
          <span class="space-actions" /> -->

          <new-button
            @click.prevent="goToNewInspection()"
            :label="$t('labels.new_button')"
          />
        </div>
      </div>

      <inspection-details
        v-if="quality_template"
        :quality_template="quality_template"
        :quality_inspects="quality_inspects"
        :goToShow="goToShowQualityInspect"
      ></inspection-details>
      <loading-message v-else />
    </div>
  </template>
  <loading-message v-else />
</template>

<script>
import CropFieldQualityRequester from "@/views/agro_exporter/requesters/quality_control/crop_field/list_export_quality_inspects.js";
import GoBackLink from "@/components/views/layout/GoBackLink.vue";
import CropFieldInfo from "@/components/views/agro_exporter/quality_control/crop_field/CropFieldInfo.vue";
import InspectionDetails from "@/components/views/agro_exporter/quality_control/crop_field/InspectionDetails.vue";

export default {
  name: "AEProductionCropFieldQualityListExportQualityInspects",
  components: {
    GoBackLink,
    CropFieldInfo,
    InspectionDetails
  },
  data() {
    return {
      load_data_general: false,
      downloading: false,
      crop_field: {},
      quality_inspects: [],
      quality_template: {}
    };
  },
  props: {
    agro_exporter_id: { required: true },
    producer_id: {
      required: true
    },
    crop_field_id: {
      required: true
    },
    exporter_process_quality_template_id: {
      required: true
    },
    current_tab: {}
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => {
        this.fetchData();
      })
    );
  },
  methods: {
    fetchData: async function () {
      await this.fetchCropField();
      await this.fetchProducerQualityTemplate();
      await this.fetchQualityInspects();
      this.load_data_general = true;
    },
    inspectsByTemplate: function (current_tab_id) {
      return this.quality_inspects.filter(
        eq_inspect => eq_inspect.quality_template_id === current_tab_id
      );
    },
    maxSamplings: function (arr) {
      return Math.max(...arr.map(eq_inspect => eq_inspect.samplings));
    },
    downloadRepXlsx: async function () {
      this.downloading = true;
      try {
        let response =
          await CropFieldQualityRequester.downloadQualityInspectsRepXlsx({
            agro_exporter_id: this.agro_exporter_id,
            crop_field_id: this.crop_field_id,
            quality_template_id: this.quality_template.id
          });

        const file = response.data;
        var fileURL = window.URL.createObjectURL(new Blob([file]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        let name = this.quality_template?.name;
        if (name) name = `${name.split(" ").join("_")}.xlsx`;
        fileLink.setAttribute("download", name ?? "reporte.xlsx");
        document.body.appendChild(fileLink);

        fileLink.click();
      } catch (error) {
        error;
      }
      this.downloading = false;
    },
    fetchCropField: async function () {
      let response = await CropFieldQualityRequester.fetchCropField(
        this.agro_exporter_id,
        this.crop_field_id,
        this.exporter_process_quality_template_id
      );
      this.crop_field = response.data;
    },
    fetchQualityInspects: async function () {
      let response = await CropFieldQualityRequester.fetchExportQualityInspects(
        this.agro_exporter_id,
        this.crop_field_id,
        this.exporter_process_quality_template_id
      );
      this.quality_inspects = response.data;
    },
    fetchProducerQualityTemplate: async function () {
      let response =
        await CropFieldQualityRequester.fetchExporterQualityTemplate(
          this.agro_exporter_id,
          this.crop_field_id,
          this.exporter_process_quality_template_id
        );
      this.quality_template = response.data;
    },
    switchTab: function (index) {
      if (this.current_tab) return Number(this.current_tab) === index;
      return index == 0;
    },
    goToShowQualityInspect: function (quality_inspect) {
      this.$router.push({
        name: "ae_quality_control_crop_field_show_quality_inspect_path",
        params: {
          agro_exporter_id: this.agro_exporter_id,
          crop_field_id: this.crop_field_id,
          quality_inspect_id: quality_inspect.id,
          producer_id: this.producer_id,
          exporter_process_quality_template_id:
            this.exporter_process_quality_template_id
        }
      });
    },
    goToNewInspection: function () {
      this.$router.push({
        name: "ae_quality_control_crop_field_new_inspection_path",
        params: {
          agro_exporter_id: this.agro_exporter_id,
          crop_field_id: this.crop_field_id,
          quality_template_id: this.quality_template?.id,
          producer_id: this.producer_id,
          exporter_process_quality_template_id:
            this.exporter_process_quality_template_id
        }
      });
    }
  }
};
</script>
